import initCycleAnalytics from '~/cycle_analytics/cycle_analytics_bundle';

document.addEventListener('DOMContentLoaded', initCycleAnalytics);
